module.exports = __webpack_public_path__ + "static/media/card-profile2.2905c963.jpg";